import { i18n } from 'i18n';

export const NOTIFICATIONS_CATEGORIES = () => ({
	joined_offers: i18n.t('Заявки одобренные'),
	rejected_offers: i18n.t('Заявки отклоненные'),
	sources: i18n.t('Площадки'),
	applications: i18n.t('Заявки на подключение'),
	invite: i18n.t('Приглашения'),
	others: i18n.t('Другие'),
	changes_in_offers: i18n.t('Обновления по офферам'),
	balance_movements: i18n.t('Движение баланса'),
});
